import React, { useEffect, useState } from 'react';
import { FormControlLabel, Grid, Tooltip, Typography } from '@mui/material';
import { StyledMarkdown } from '@/components/styled/markdown';
import { StyledRadio } from '../../../styled/radio.input';
import { StyledRadioGroup } from '../../../styled/radiogroup.input';
import DesignSkillStackJson from '@/json/design-skill-stack/data.json';
import parse from 'html-react-parser';
import styles from '../dss.module.scss';
export const RadioInput = ({
  field,
  design,
  handleChange,
  value,
  questionType,
  description,
}: any) => {
  const { experienceLabels, aspirationLabels, masteryLabels } =
    DesignSkillStackJson;
  const [hasToolTip, setHasToolTip] = useState(false);
  const [title, setTitle] = useState();
  const [tooltipTrigger, setTooltipTrigger] = useState();
  const [trailingTitle, setTrailingTitle] = useState<string>('');

  useEffect(() => {
    if (field?.title.indexOf('<span>')) {
      const titleArr = field.title.split('<span>');

      if (titleArr) {
        if (titleArr.indexOf(0)) {
          setTitle(titleArr[0]);
        }

        if (titleArr.indexOf(1)) {
          const tooltipText = titleArr[1];
          const tooltipTextArr = tooltipText.split('</span>');

          if (tooltipTextArr) {
            setTooltipTrigger(
              tooltipTextArr.indexOf(0) ? tooltipTextArr[0] : ''
            );
            setTrailingTitle(
              tooltipTextArr.indexOf(1) ? tooltipTextArr[1] : ''
            );
          }
        }
      }

      setHasToolTip(true);
    }
  }, [field]);

  return (
    <Grid>
      {field && (
        <>
          <Typography
            style={{ color: design.colors.question }}
            className={styles.input}
          >
            {title && hasToolTip ? (
              <>
                {title ? parse(title) : ''}
                <Tooltip
                  componentsProps={{
                    tooltip: {
                      sx: {
                        backgroundColor: '#ECF8FF',
                        color: '#000',
                        padding: '25px',
                      },
                    },
                    arrow: {
                      sx: {
                        color: '#ECF8FF',
                      },
                    },
                  }}
                  title={
                    <>
                      <Typography
                        sx={{
                          fontSize: '14px',
                        }}
                      >
                        Glossary Definition
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: '16px',
                          fontWeight: '700',
                          marginTop: '10px',
                        }}
                      >
                        {tooltipTrigger ? parse(tooltipTrigger) : ''}
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: '14px',
                          marginTop: '10px',
                        }}
                      >
                        {field.description}
                      </Typography>
                    </>
                  }
                  arrow
                >
                  <Typography
                    sx={{
                      fontWeight: 'bold',
                      display: 'inline',
                      textDecoration: 'underline',
                    }}
                    className={styles.input}
                  >
                    {tooltipTrigger ? parse(tooltipTrigger) : ''}
                  </Typography>
                </Tooltip>
              </>
            ) : (
              <>{field?.title ? parse(field.title) : ''} </>
            )}
            {trailingTitle ? parse(trailingTitle) : ''}
          </Typography>
          {description ? (
            <StyledMarkdown
              className='question-description'
              design={design}
              type={'question'}
            >
              {description}
            </StyledMarkdown>
          ) : undefined}
          <StyledRadioGroup
            name={field.id}
            onChange={handleChange}
            value={value}
            design={design}
          >
            {field.options.map((option: any, index: number) => (
              <FormControlLabel
                key={option.id}
                value={option.value}
                sx={{
                  // https://stackoverflow.com/questions/19248985/how-to-prevent-shifting-when-changing-border-width
                  transition: 'box-shadow 0.1s linear',
                  borderColor:
                    value === option.value
                      ? 'transparent'
                      : design.colors.question,
                  boxShadow:
                    value === option.value
                      ? `0 0 0 5px ${design.colors.button}`
                      : `0 0 0 1px ${design.colors.question}`,
                }}
                control={<StyledRadio design={design} size='small' />}
                label={
                  <div key={index}>
                    <Typography sx={{ fontWeight: '700', display: 'inline' }}>
                      {masteryLabels[index]}
                    </Typography>
                    {` `}
                    <Typography
                      sx={{ fontWeight: 'normal', display: 'inline' }}
                    >
                      {questionType === 1
                        ? experienceLabels[index]
                        : aspirationLabels[index]}
                    </Typography>
                  </div>
                }
              />
            ))}
          </StyledRadioGroup>
        </>
      )}
    </Grid>
  );
};
